export const mapSettings = {
  zoom: 8,
};

// Budapest
export const defaultMapCenter = {
  lat: 47.478325,
  lng: 19.055449,
};

export const mapStyle = [
  {
    featureType: 'administrative',
    elementType: 'all',
    stylers: [{
      visibility: 'on',
    },
    {
      lightness: 33,
    },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{
      color: '#f2e5d4',
    }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{
      color: '#c5dac6',
    }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [{
      visibility: 'on',
    },
    {
      lightness: 20,
    },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [{
      lightness: 20,
    }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{
      color: '#c5c6c6',
    }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{
      color: '#e4d7c6',
    }],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [{
      color: '#fbfaf7',
    }],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [{
      visibility: 'on',
    },
    {
      color: '#acbcc9',
    },
    ],
  },
];

export const customIcons = {
  SamsungMSC: {
    icon: require('../assets/map/map_marker_samsung.png'),
  },
  TMX: {
    icon: require('../assets/map/map_marker_tmx.png'),
  },
  Postapont: {
    icon: require('../assets/map/map_marker_posta.png'),
  },
  MediaMarkt: {
    icon: require('../assets/map/map_marker_media.png'),
  },
  error: {
    icon: require('../assets/map/map_marker_error.png'),
  },
};

export const GOOGLE_MAPS_API_KEY = 'AIzaSyALqvq73QAYoRJTKI3yKAE9dsXnnrygLSg';
